module.exports = __webpack_public_path__ + "static/img/4.1d6ec6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/4.png
// module id = ePla
// module chunks = 0